import styled from 'styled-components';
export const Container = styled.div `
  .rc-slider {
    height: 16px;
    padding: var(--space-150) 0;
    margin: 0 var(--space-200);

    &:before {
      content: '';
      position: absolute;
      left: -8px;
      width: 8px;
      height: 2px;
      background-color: var(--text-primary);
    }

    &:after {
      content: '';
      position: absolute;
      right: -8px;
      width: 8px;
      height: 2px;
      background-color: var(--border-secondary);
    }
  }

  .rc-slider-disabled {
    background-color: transparent;
  }

  .rc-slider-step {
    height: 2px;
  }

  .rc-slider-handle {
    width: 16px;
    height: 16px;
    background: var(--text-primary);
    border-radius: 50%;
    border: 0;
    outline: 0;
    opacity: 1;
    margin-top: -7px;

    &-dragging {
      box-shadow: 0 0 0 2px var(--text-primary) !important;
    }
  }
`;
